import React from 'react';
import styled from 'styled-components';
import { FormSection } from 'redux-form';

import { Checkbox, LABEL_POSITION } from 'components/Shared/Forms';
import { INPUTS } from 'theme';

const StyledCheckbox = styled(Checkbox)`
    margin-top: -${INPUTS.PADDING.X};
    margin-bottom: -${INPUTS.PADDING.X};
`;

const InfoWindowBehavior = () => (
    <FormSection name="behavior">
        <StyledCheckbox name="openByDefault" label="Open by default" labelPosition={LABEL_POSITION.RIGHT} />
        <StyledCheckbox name="closeOnMapClick" label="Close on map click" labelPosition={LABEL_POSITION.RIGHT} />
        <StyledCheckbox
            name="closeWhenOthersOpen"
            label="Close when other popups open"
            labelPosition={LABEL_POSITION.RIGHT}
        />
    </FormSection>
);

export default InfoWindowBehavior;
